import React, { useState, useEffect } from 'react';
import AppTheme from '../../AppTheme';

import disableScroll from 'disable-scroll';
import Modal from 'react-native-modal';
import { View, StyleSheet, ActivityIndicator } from 'react-native';
import * as AlertService from "../../utils/services/AlertLoaderService";

const CommonLoaderComponent = (props) => {

    const [showLoader, setShowLoader] = useState(false);
    const [backdropOpacity, setBackdropOpacity] = useState(0.9);

    useEffect(() => {
        AlertService.loaderModal.getLoader().subscribe((LoaderData: any) => {
            if (LoaderData) {
                setShowLoader(LoaderData.isLoader);
                if (LoaderData.backdropOpacity) {
                    setBackdropOpacity(LoaderData.backdropOpacity)
                }
            } else {
                // clear messages when empty message received
            }
        });
    })
    return (
        <Modal deviceHeight={AppTheme.appHeight}
            backdropOpacity={backdropOpacity}
            backdropColor={AppTheme.color.white}
            isVisible={showLoader}>
            <View style={[styles.container]}>
                <ActivityIndicator size="large" color={AppTheme.color.primary} />
            </View>
        </Modal>
    )
}

export default CommonLoaderComponent;

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        height: '100%'
    },
    modalTitle: {
        fontSize: 14,
        color: AppTheme.color.grey.disable
    },
    modalButton: {
        width: 100,
        backgroundColor: AppTheme.color.primary,
        textAlign: "center",
        alignContent: "center",
        padding: 4,
        marginTop: 12,
        flex: 1,
        justifyContent: 'flex-end',
        height: 20
    }
})